module.exports = "/_next/static/resources/box-eb8c974356b40679f2ba5dc393148d84.jpg";